import { Arg, Ctx, Directive, Mutation, Resolver } from 'type-graphql'

import { createDataSample } from '../../controllers/create-data-sample.js'
import { DataSample } from './data-sample.js'
import { NewDataSample } from './data-sample-type.js'

@Resolver(DataSample)
export class DataSampleMutation {
  @Directive('@privilege(category: "data-sample", privilege: "mutation", domainOwnerGranted: true)')
  @Directive('@transaction')
  @Mutation(returns => DataSample, {
    description:
      'Creates a new data sample record with collected values, metadata, and links to the dataset. Used for both manual and automated data collection processes.'
  })
  async createDataSample(
    @Arg('dataSample') dataSample: NewDataSample,
    @Ctx() context: ResolverContext
  ): Promise<DataSample> {
    return await createDataSample(dataSample, context)
  }
}
